import actions from "./actions";

const inspectionCategoryModule = {
  state: {},
  mutations: {},
  actions,
  getters: {},
};

export default inspectionCategoryModule;
